import axios from '@/axios.js'
let token = localStorage.getItem('accessToken');
let entityURL = 'eshops'; // variant depending on entity URLs
let apiEndpoint = localStorage.getItem('apiEndpoint');

axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    shops: [],
    shop: {},
    displayShopPopUp: false,
    shopPopUpTitle: '',
}

const getters = {
    getShops: (state) => (state.shops),
    getShop: (state) => (state.shop),
    getDisplayShopPopUp: (state) => (state.displayShopPopUp),
    getShopPopUpTitle: (state) => (state.shopPopUpTitle),
}

const actions = {
    // Add new shop
    async addNewShop({ commit }, payload) {
        const response = await axios.post(`${entityURL}/add`, payload)
        commit('ADD_NEW_SHOP', response.data.object)
    },

    // Fetch shops
    async fetchShops({ commit }) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_SHOPS', response.data)
    },

    // Fetch shop
    async fetchShop({ commit }, payloadId) {
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_SHOP', response.data)
    },

    // Update shop
    async updateShop({ commit }, payload) {
        const response = await axios.put(`${entityURL}/update/${payload.id}`, payload)
        commit('UPDATE_SHOP', response.data.object)
    },

    // Delete shop
    async deleteShop({ commit }, payloadId) {
        const response = await axios.delete(`${entityURL}/delete/${payloadId}`)
        if (response.data.message === 'Successfully Deleted') {
            commit('DELETE_SHOP', payloadId)
        }
    },

    // Toggle pop up.
    toggleShopsPopUp({ commit }, value) {
        commit('TOGGLE_SHOPS_POP_UP', value)
    },

    // Set pop up title.
    setShopPopUpTitle({ commit }, value) {
        commit('SET_SHOP_POP_UP_TITLE', value)
    },

    // Set shop
    setShop({ commit }, payload) {
        commit('SET_SHOP', payload)
    },

    // Setter for shop name
    setShopName({ commit }, value) {
        commit('SET_SHOP_NAME', value)
    },

    // Setter for shop url
    setShopUrl({ commit }, value) {
        commit('SET_SHOP_URL', value)
    },

    // Setter for shop checked
    setShopChecked({ commit }, value) {
        commit('SET_SHOP_CHECKED', value)
    },

    // Setter for shop live status
    setShopLiveStatus({ commit }, value) {
        commit('SET_SHOP_LIVE_STATUS', value)
    },

    // Setter for shop price_x_path
    setShopPriceXPath({ commit }, value) {
        commit('SET_SHOP_PRICE_X_PATH', value)
    },

    // Setter from shop seller_x_path
    setShopSellerXPath({ commit }, value) {
        commit('SET_SHOP_SELLER_X_PATH', value)
    },
}

const mutations = {
    ADD_NEW_SHOP: (state, data) => (state.shops.push(data)),
    SET_SHOPS: (state, data) => (state.shops = data),
    SET_SHOP: (state, data) => (state.shop = data),
    UPDATE_SHOP: (state, data) => {
        let shopIndex = state.shops.findIndex(x => x.id === data.id)
        if (shopIndex !== -1) {
            state.shops.splice(shopIndex, 1, data)
            state.shop = data
        }
    },
    DELETE_SHOP: (state, data) => {
        let shopIndex = state.shops.findIndex(x => x.id === data)
        if (shopIndex !== -1) {
            state.shops.splice(shopIndex, 1)
        }
    },
    TOGGLE_SHOPS_POP_UP: (state, value) => (state.displayShopPopUp = value),
    SET_SHOP_POP_UP_TITLE: (state, value) => (state.shopPopUpTitle = value),
    SET_SHOP_NAME: (state, value) => (state.shop.name = value),
    SET_SHOP_URL: (state, value) => (state.shop.url = value),
    SET_SHOP_PRICE_X_PATH: (state, value) => (state.shop.price_xpath = value),
    SET_SHOP_SELLER_X_PATH: (state, value) => (state.shop.seller_xpath = value),
    SET_SHOP_LIVE_STATUS: (state, value) => (state.shop.live_status = value),
    SET_SHOP_CHECKED: (state, value) => (state.shop.checked = value),
}

export default { state, getters, actions, mutations }
